import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Layout } from "@/components/Layout";
import { AuditLog } from "@/components/AuditLog";
import NotFound from "@/pages/not-found";
import { useAuthMe } from "./hooks/useLocalStorage";
import { useEffect } from "react";
import { InterfaceTable } from "./components/Interfaces/InterfaceTable";
import { BreadcrumbProvider } from "./components/BreadcrumbContext";
import InterfaceSelect from "./components/Interfaces/InterfaceSelect";
import { InterfacesRepo } from "./components/Interfaces/InterfacesRepo";


function Router() {
  return (
    <BreadcrumbProvider>
      <Layout>
        <Switch>
          <Route path="/">
            <InterfaceTable fromType="Internal" formRoute="/" />
          </Route>
          <Route path="/ExternalInterface">
            <InterfaceTable fromType="External" formRoute="ExternalInterface" />
          </Route>

          <Route path="/InterfaceRepository">
            <InterfacesRepo />
          </Route>

          <Route path="/addInterface">
            <InterfaceSelect />
          </Route>
          {/* <Route path="/audit" component={AuditLog} /> */}
          <Route component={NotFound} />
        </Switch>
      </Layout>
    </BreadcrumbProvider>
  );
}

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { data, isLoading, isError } = useAuthMe();

  useEffect(() => {
    if (isError) {
      console.log("Authentication check failed");
    }
  }, [isError]);

  // if (isLoading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-screen">
  //       <div className="text-center">
  //         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
  //         <p className="text-muted-foreground">redirecting...</p>
  //       </div>
  //     </div>
  //   );
  // }

  // if (isError || !data) {
  //   return <RedirectingScreen />;
  // }

  return <>{children}</>;
}

function App() {
  useAuthMe();
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <AuthGuard>
          <Router />
        </AuthGuard>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
